import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { DateTime } from "luxon";
import { Board, List } from "@freetech/models/freelo";
interface MoveListParams {
  boardId: string;
  listId: string;
  destinationIndex: number;
}

export const moveList = async (params: MoveListParams): Promise<void> => {
  const { boardId, listId, destinationIndex } = params;

  try {

    const boardRef = doc(db, "boards", boardId);
    const boardDoc = await getDoc(boardRef);
    
    if (!boardDoc.exists()) {
      throw new Error("Board not found");
    }

    const board = boardDoc.data() as Board;
    const currentListOrder = board.listOrder || [];


    const currentIndex = currentListOrder.indexOf(listId);
    if (currentIndex === -1) return;


    const newListOrder = Array.from(currentListOrder);
    newListOrder.splice(currentIndex, 1);
    newListOrder.splice(destinationIndex, 0, listId);


    await updateDoc(boardRef, {
      listOrder: newListOrder,
      updatedAt: DateTime.now().toISO(),
    });

  } catch (error) {
    console.error('Error moving list:', error);
    throw error;
  }
}; 